import type { DefaultCommand } from '../../../../types/chat-command';

export type { DefaultCommand } from '../../../../types/chat-command';

const isOtherFeatureCommand = (command: DefaultCommand): boolean => (
  Boolean(command.id && command.name?.trim())
  && command.isDisplay !== false
  && command.isHasPermission !== false
);

export const getOtherFeatureCommands = (commands: DefaultCommand[] | undefined): DefaultCommand[] => (
  Array.isArray(commands) ? commands.filter(isOtherFeatureCommand) : []
);
